// CommonCtx.js

import { createContext, useContext } from 'react';

export const AuthContext = createContext({
    ppms : '',
    setPpms: () => {},
    port : '',
    setPort: () => {},
    ip: null,
    setIp: () => {},
    user: {},
    setUser: () => {},
    //setUser: (_ : any) => {},
    mode: null,
    setMode: () => {},
    ml: {},
    setMl: () => {},
    camera: null,
    setCamera: () => {}
});

export const useAuth = () => useContext(AuthContext);


